<template>
  <div id="detail">
    <!--进度条-->
    <loading :num="loadingNum" />
    <!-- <div class="icon">
      <img
        @click="cliDetail(1)"
        class="icon-image"
        src="static/img/detail.png"
        alt=""
      />
    </div> -->

    <div class="logo">
      <img class="logo-img" src="static/img/logo.png" alt="" />
    </div>
    <div id="title">
      <span>{{ form.title }}</span>
      <img
        @click="cliDetail(1)"
        class="title-image"
        src="static/img/detail2.png"
        alt=""
      />
      <div class="title-imgName">详 情</div>
    </div>
    <div class="canvasBOX">
      <canvas id="detailBox" class="detailBox"></canvas>
      <div
        class="message"
        @click="cliDetail(0)"
        :style="{ bottom: `${isShow}%` }"
      >
        <div class="box" @click="cliDetailBox()">
          <div class="close">
            <img @click="cliDetail(0)" src="static/img/close.png" alt="" />
          </div>
          <div class="message-show">
            <div id="message_title">{{ form.title }}</div>
            <div id="message_content">{{ form.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import loading from '@/components/loading/index.vue'
export default {
  name: 'App',
  data() {
    return {
      form: {
        name: '',
        title: '',
        content: '',
        loadingCode: 0
      },
      // 基础值
      canvas: null,
      renderer: null,
      controls: null,
      camera: null,
      scene: null,
      objLoader: null,
      animateMsg: null,
      objMaterial: [], // 模型纹理管理
      model: [], // 模型数据
      modelMsg: [
        // {
        //   // 本体
        //   objUrl: 'static/model/3843/3843.OBJ', // 模型地址
        //   texture: new THREE.TextureLoader().load(
        //     'static/model/3843/3843_Base_Color.jpg'
        //   ), // 模型贴图
        //   metallicImg: new THREE.TextureLoader().load(
        //     'static/model/3843/3843_Metallic.jpg'
        //   ), // 金属度贴图
        //   AOImg: new THREE.TextureLoader().load(
        //     'static/model/3843/3843_Mixed_AO.jpg'
        //   ), // AO贴图
        //   normalImg: new THREE.TextureLoader().load(
        //     'static/model/3843/3843_Normal_OpenGL.jpg'
        //   ), // 法线度贴图
        //   roughnessImg: new THREE.TextureLoader().load(
        //     'static/6879/t/3843_Roughness.jpg'
        //   ), // 粗糙贴图
        //   position: [0, 0, 0]
        // }
      ], // 导入模型数据
      initP: [0, 0, 70], // 设置初始位置
      scale: [0.15, 0.15, 0.15],
      isShow: -100, //展示下拉
      loadingNum: 0
    }
  },
  methods: {
    //获取数据
    getData() {
      var id = window.location.href.split('?')[1].split('=')[1]
      console.log('decodeURI', id)
      var url = 'static/js/model.json'
      var request = new XMLHttpRequest()
      request.open('get', url)
      request.send(null)
      request.onload = () => {
        if (request.status == 200) {
          var json = JSON.parse(request.responseText)
          let data
          json.map((e) => {
            if (e.id === id) data = e
          })
          if (data) {
            data.url = data.url.map((e) => {
              e.texture = new THREE.TextureLoader().load(e.texture)
              e.metallicImg = new THREE.TextureLoader().load(e.metallicImg)
              e.AOImg = new THREE.TextureLoader().load(e.AOImg)
              e.normalImg = new THREE.TextureLoader().load(e.normalImg)
              e.roughnessImg = new THREE.TextureLoader().load(e.roughnessImg)
              return e
            })
            this.modelMsg = data.url
            //基础参数及其优先加载哪个模型
            this.form = {
              name: data.name,
              title: data.title,
              content: data.content,
              loadingCode: data.loadingCode
            }
            this.scale = data.scale || this.scale
          }
          console.log('数据', json, data)
          this.init()
          this.animate()
        }
      }
    },
    // 设置画布
    setCanvas() {
      let canvas = document.querySelector('#detailBox')
      this.renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer.setClearColor(0x000000, 0)
    },
    // 初始化相机
    setCamera() {
      this.camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        1000
      )
      // 创建一个点灯光，并给模型添加灯光
      var pointLight = new THREE.PointLight(0xffffff, 0.4, 0)
      this.camera.add(pointLight)
      this.camera.position.set(this.initP[0], this.initP[1], this.initP[2]) // 设置相机位置
      this.camera.lookAt(0, 0, 0)
    },
    // 设置相机的控制器
    setControls() {
      // 控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      // 是否自动旋转
      this.controls.autoRotate = false
      // 设置旋转速度
      this.controls.rotateSpeed = 2
      // 使动画循环使用时阻尼或自转 意思是否有惯性
      this.controls.enableDamping = false
      // 设置相机距离原点的最远距离
      this.controls.minDistance = 30
      // 设置相机距离原点的最远距离
      this.controls.maxDistance = 800
      // //是否开启右键拖拽
      // this.controls.noPan = false
      this.controls.enablePan = false
      // //是否可以缩放
      // this.controls.enableZoom = false
    },
    // 设置环境
    setScene() {
      if (this.sence) this.sence.dispose()
      this.scene = new THREE.Scene()
      // 创建一个环境灯光
      var ambientLight = new THREE.AmbientLight(0xffffff, 1)
      this.scene.add(ambientLight)
      // 把视角放入环境
      this.scene.add(this.camera)
      // 辅助线
      // var axes = new THREE.AxesHelper(10)
      // this.scene.add(axes)
    },
    // 设置模型
    setObj() {
      this.model = []
      const objLoader = new OBJLoader()
      this.modelMsg.forEach((e, i) => {
        objLoader.load(
          e.objUrl,
          (root) => {
            root.traverse((child) => {
              if (child instanceof THREE.Mesh) {
                // 设置模型皮肤
                this.objMaterial[i] = new THREE.MeshPhysicalMaterial({
                  map: e.texture,
                  normalMap: e.normalImg, // 法线贴图
                  roughnessMap: e.roughnessImg, // 粗糙度贴图
                  metalnessMap: e.metallicImg, // 金属度贴图
                  // envMap:e.AOImg// 环境贴图
                })

                child.material = this.objMaterial[i]
              }
            })
            this.model[i] = root
            let scale = this.scale
            this.model[i].scale.set(scale[0], scale[1], scale[2]) // 缩放模型
            let p = e.position
            this.model[i].position.set(p[0], p[1], p[2]) // 多模型，组合模型
            if (e.rotation) this.model[i].rotation.y = e.rotation
            this.scene.add(this.model[i])
          },
          (xhr) => {
            if (i === this.form.loadingCode) {
              if (xhr.lengthComputable) {
                var percentComplete = (xhr.loaded / xhr.total) * 100
                this.loadingNum = Math.round(percentComplete, 2)
                console.log(Math.round(percentComplete, 2) + '% downloaded')
              }
            }
          }
        )
      })
    },
    // 循环动画
    animate() {
      this.animateMsg = requestAnimationFrame(this.animate)
      if (this.controls) this.controls.update()
      if (this.renderer && this.scene && this.camera)
        this.renderer.render(this.scene, this.camera)
    },
    // 节流请求
    throttle(f, n) {
      var flag = true
      return () => {
        if (flag) {
          setTimeout(() => {
            f.call(this)
            flag = true
          }, n)
        }
        flag = false
      }
    },
    cliDetail(isClose) {
      if (isClose) {
        document.getElementsByClassName('message')[0].style.bottom = '0'
      } else {
        document.getElementsByClassName('message')[0].style.bottom = '-100%'
      }
    },
    cliDetailBox() {
      event.stopPropagation()
    },
    init() {
      this.setCanvas()
      this.setCamera()
      this.setControls()
      this.setScene()
      this.setObj()
    }
  },
  components: {
    loading
  },
  mounted() {
    setTimeout(() => {
      this.getData()
    })
    // window.onresize = this.throttle(() => {
    //   console.log('高度发生了变化')
    //   this.init()
    // }, 100)
  }
}
</script>
<style lang="scss" scoped>
.detail {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.canvasBOX {
  position: absolute;
  width: 100vw;
  height: 100vh;
  // background-size: cover;
  // background: linear-gradient(to top right, #f6f5f0, #fefefd);
  background: linear-gradient(to bottom, #10231d, #406363);
  overflow: hidden;
  /* 标题 */
  .title {
    position: fixed;
    display: flex;
    align-items: stretch;
    vertical-align: middle;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    height: 1.5rem;
    line-height: 1.5rem;
    // font-weight: bold;
    font-family: 'Source Han Serif CN';
    color: #dab16d;
    font-weight: bold;
    z-index: 1;

    .title-imgL {
      display: inline-block;
      vertical-align: middle;
      height: 1.5rem;
      line-height: 1.5rem;
      // background-color: red;
    }

    .title-img {
      height: 1rem;
      margin-top: 0.25rem;
    }

    .title-content {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      margin: 0 12px;
      padding: 0 !important;
      // min-width: 240px;
      width: 100%;
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;

      // background-color: red;
      // background-color: lightblue;

      span {
        position: absolute;
        top: 0%;
        width: 100%;
        height: 1.5rem;
        line-height: 1.5rem;
        transform: translateX(-50%);
        // background-color: blue;
      }

      p {
        // padding: 10px;
        // background-color: green;
      }
    }
  }
}
.icon {
  position: fixed;
  cursor: pointer;
  /* width: 100%; */
  right: 0;
  bottom: 3%;
  z-index: 1;
}

.icon-image {
  float: right;
  width: 45px;
  height: 45px;
  margin: 5px 20px;
  /* pointer-events: none; */
}
.message {
  position: fixed;
  overflow: hidden;
  height: 100%;
  z-index: 2;
  bottom: -100%;
  opacity: 0.8;
  transition: 0.7s;
  width: 100%;
}

.message .box {
  width: 100%;
  // height: 50%;
  position: absolute;
  background: rgba(40, 40, 40, 0.6);
  bottom: 0;
  right: 0;
}

.close {
  position: absolute;
  top: 0;
  right: 2%;
  // width: 100%;
  height: 60px;
}

.close img {
  margin: 15px 15px;
  width: 12px;
  cursor: pointer;
}

.message-show {
  width: 100%;
  height: calc(100% - 90px);
  margin-bottom: 10px;
  display:flex;
  flex-direction:column;
  /* background-color: red; */

  .message-show::-webkit-scrollbar {
    display: none;
  }

  #message_title {
    font-size: 1.5em;
    /* font-family: '华文楷体'; */
    font-family: 'KaiTi';
    // font-family: '楷简';
    font-weight: 400;
    width: calc(100% - 40px);
    // height: 50px;
    line-height: 1.2em;
    text-align: center;
    // color: rgba(254, 254, 254, 1);
    padding: 20px 20px 10px;
    clear: both;
    color: #ffe8b1;
  }

  #message_content {
    // font-family: '楷简';
    font-family: 'MicrosoftYaHei';
    font-size: 16px;
    line-height: 30px;
    height: calc(50vh - 50px);

    padding: 0 7% 5%;
    color: #ffe8b1;
    width: 86%;
    display: block;
    text-indent: 2em;
    text-align: justify;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}
.logo {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  padding-bottom: 20px;
  pointer-events: none;
  .logo-img{
    width: 100px;
  }
}
#title {
  position: fixed;
  top: 13%;
  right: 4.7%;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: right;
  color: #ffe8b1;
  writing-mode: vertical-rl;
  font-family: '楷简';
  align-items: center;
  span {
    font-size: 1.7rem;
    pointer-events: none;
  }
  .title-image {
    width: 45px;
    height: 45px;
    padding-top: 20px;
  }
  .title-imgName {
    font-family: 'KaiTi';
    font-size: 16px;
    color: #9e8e60;
    writing-mode: initial;
  }
}
</style>



// WEBPACK FOOTER //
// public/detail/detail.vue